<template>
  <div class="panel panel-default">
    <div
      class="panel-heading"
      role="button"
      @click="expanded = !expanded">
      <span class="panel-title">{{ setCode }} Standards ({{ selected.length }})</span>
    </div>
    <template v-if="expanded">
      <div class="panel-body">
        <StandardsTypeahead
          :set-code="setCode"
          :id="`${setCode}-standards`"
          @selected="add" />

      </div>
      <draggable
        tag="ul"
        :id="`${id}-standards-list`"
        :list="selectedInternal"
        @change="sequenceChanged"
        handle=".draggable-handle"
        class="list-group">
        <li
          class="list-group-item"
          v-for="(r, index) of selectedInternal"
          :key="r">
          <div class="grow draggable-handle">
            <p><a
              :href="standardURL(r)"
              target="_blank"
              :title="`Edit standard ${r}`">{{ r }}</a></p>
            <p v-if="standardsMap && standardsMap[r]" v-html="standardsMap[r].standard_text"/>
            <div class="alert alert-info light" v-if="standardsMap && standardsMap[r] && standardsMap[r].core_purpose">
              <b>Core Purpose:</b>
              {{ standardsMap[r].core_purpose }}
            </div>
          </div>
          <a
            class="remove text-danger"
            role="button"
            :aria-label="`Remove standard ${r}`"
            @click="remove(index)">
            <i class="fa fa-times"/>
          </a>
        </li>
      </draggable>
    </template>
  </div>
</template>

<script>
import { Collapse } from 'uiv'
import draggable from 'vuedraggable'
import StandardsTypeahead from './StandardsTypeahead'
import { pathwaysUrls } from '@/links'

export default {
  name: 'SelectStandards',
  components: {
    Collapse,
    StandardsTypeahead,
    draggable
  },
  props: {
    id: {
      type: String,
      required: true
    },
    setCode: {
      type: String,
      default: 'CCSS'
    },
    selected: {
      type: Array,
      default: () => []
    },
    standardsMap: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      selectedInternal: this.selected || [],
      expanded: false
    }
  },
  methods: {
    add({ standard_long_ref }) {
      this.selectedInternal = [...this.selectedInternal, standard_long_ref]
      this.$emit('update:selected', [...this.selectedInternal])
    },
    remove(index) {
      this.selectedInternal.splice(index, 1)
      this.$emit('update:selected', [...this.selectedInternal])
    },
    sequenceChanged(evt) {
      if (evt.moved) {
        this.$emit('update:selected', [...this.selectedInternal])
      }
    },
    standardURL(ref) {
      return pathwaysUrls.editStandard(this.setCode, ref)
    }
  },
  watch: {
    selected(newValue) {
      this.selectedInternal = newValue || []
    }
  }
}
</script>

<style lang="less" scoped>
.panel {
  margin-bottom: 0.5em;
}
.panel-heading:hover {
  text-decoration: underline;
}
.list-group-item {
  display: flex;

  .grow {
    flex: 1 1 auto;
  }
  .remove {
    flex: 0 0 auto;
  }
}
.alert {
  margin-bottom: 0;
  padding: 0.5em;
}
</style>
